import React from 'react';
import { Tooltip } from '@scale/scaleui';
import { ReviewLevel } from '@scale/shared-types';
import { QualityPayPill } from 'react-scale/components/Expert/Earnings/components/descriptionCell';
import { usePayRateQueryTasksPage } from 'react-scale/remotasks.com/components/Expert/Dashboard/data/usePayRateQuery';
import _ from 'lodash';

type ChipQualityPayProps = {
  projectId: string | undefined;
  reviewLevel: ReviewLevel | undefined;
  assignmentId: string | undefined;
};

/**
 * If the pay rate cards for this assignment indicate extra earnings for quality pay, render this pill.
 * Otherwise, it's a no-op.
 *
 * (To spoof for testing, force claim a chat task from Andrea's test Chat Task project)
 */
export const ChipQualityPay: React.FC<ChipQualityPayProps> = ({
  projectId,
  reviewLevel,
  assignmentId,
}) => {
  const currentAssignment = { id: assignmentId };

  const { data: payRateCardData, isLoading: isLoadingPayRateCard } = usePayRateQueryTasksPage(
    {
      projectId,
      reviewLevel: String(reviewLevel),
    },
    currentAssignment,
    {
      enabled: !_.isNil(projectId) && !_.isNil(reviewLevel) && !_.isNil(assignmentId),
    },
  );

  // has QBP (quality-based-pay) if payRateInfo.onTargetEarningsCents is present and > 0
  const attemptIsQbp = Boolean(payRateCardData?.payRateInfo?.onTargetEarningsCents);

  if (isLoadingPayRateCard || !attemptIsQbp) {
    return null;
  }

  return (
    <Tooltip
      target={
        <span className="ml-4">
          <QualityPayPill />
        </span>
      }
      text={
        <div className="flex flex-col gap-1 text-center text-sm w-52 font-medium">
          Additional incentives per task if your work is accepted
        </div>
      }
      delayDuration={0}
      asChild={false}
    />
  );
};
